import {RemoteGetB2BBeneficiaryStatus} from 'data/usecases/others/selection-flow/b2b/remote-get-b2b-beneficiary-status';
import {GetB2BBeneficiaryStatus} from 'domain/usecases/others/selection-flow/b2b/get-b2b-beneficiary-status';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {B2BEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetB2BBeneficiaryStatus = (): GetB2BBeneficiaryStatus =>
	new RemoteGetB2BBeneficiaryStatus(
		makeBFFApiUrl(B2BEndPoints.companyAuthorization),
		makeAuthorizeHttpClientDecorator(),
	);
